import styled from "@emotion/styled";

export const IconImage = styled.img`
  width: 50px;
  height: 50px;
  object-fit: cover;
`;
